<template>
  <q-layout view="hHh lpR fFf">
    <q-header elevated class="bg-brown text-white">
      <q-toolbar>
        <q-btn flat dense round @click="leftDrawerOpen = !leftDrawerOpen" aria-label="Menu" icon="menu" />

        <q-toolbar-title> 學生競賽登錄系統 </q-toolbar-title>
        <q-toggle v-model="dark" keep-color color="lime" :icon="dark ? 'dark_mode' : 'light_mode'"></q-toggle>
        <span class="desktop-only">{{ isLogin() ? user.username : "" }}</span>
        <q-icon :name="roleIcon" size="sm" class="q-ml-sm desktop-only"></q-icon>
        <q-btn v-if="isLogin()" flat label="登出" icon="logout">
          <g-menu label="確定要登出系統嗎?" @confirm="sysLogout"></g-menu>
        </q-btn>
      </q-toolbar>
    </q-header>
    <q-drawer v-model="leftDrawerOpen" show-if-above bordered :width="200">
      <q-list>
        <q-item-label header class="text-subtitle1">系統功能</q-item-label>
        <q-item :disable="!isLogin()" to="/ContestList">
          <q-item-section avatar>
            <q-icon name="emoji_events" />
          </q-item-section>
          <q-item-section>
            <q-item-label>競賽獲獎列表</q-item-label>            
          </q-item-section>
        </q-item>
        <q-item v-if="isAdmin" to="/RoleList">
          <q-item-section avatar>
            <q-icon name="group" />
          </q-item-section>
          <q-item-section>
            <q-item-label>登入帳號管理</q-item-label>            
          </q-item-section>
        </q-item>
        <q-item v-if="isAdmin" to="/SyncT484">
          <q-item-section avatar>
            <q-icon name="sync" />
          </q-item-section>
          <q-item-section>
            <q-item-label>同步表4-8-4</q-item-label>            
          </q-item-section>
        </q-item>
        <q-separator v-if="isTyper || isAdmin" />
        <q-item-label v-if="isTyper || isAdmin" header class="text-subtitle1">表4-8-4清查作業</q-item-label>
        <q-item v-if="isTyper || isAdmin" to="/downLoadExcel">
          <q-item-section avatar>
            <q-icon name="file_download" />
          </q-item-section>
          <q-item-section>
            <q-item-label>下載清查媒體檔</q-item-label>            
          </q-item-section>
        </q-item>
        <q-item v-if="isTyper || isAdmin" to="/upLoadExcel">
          <q-item-section avatar>
            <q-icon name="file_upload" />
          </q-item-section>
          <q-item-section>
            <q-item-label>上傳清查媒體檔</q-item-label>            
          </q-item-section>
        </q-item>
        <q-item v-if="isAdmin" to="/upLoadExcelLogs">
          <q-item-section avatar>
            <q-icon name="groups" />
          </q-item-section>
          <q-item-section>
            <q-item-label>上傳清查記錄</q-item-label>            
          </q-item-section>
        </q-item>
      </q-list>
    </q-drawer>

    <q-page-container>
      <q-page padding>
        <router-view />
      </q-page>
    </q-page-container>

    <q-footer bordered class="bg-grey-8 text-white">
      <q-toolbar>
        <div>
          Copyright © Southern Taiwan University of Science and Technology All Rights
          Reserved
        </div>
        <!-- <q-toolbar-title>
         
        </q-toolbar-title> -->
      </q-toolbar>
    </q-footer>
  </q-layout>
</template>

<script setup>
import { useMsg } from "@/methods/useMsg";
import { ref, onMounted, watch } from "vue";
import { useStore } from "@/store/useStore";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import { merge, fromEvent, throttleTime } from "rxjs";
import { useAxios } from "@/methods/useAxios";

import { useQuasar } from "quasar";
import moment from "moment";

import GMenu from "@/components/pub/GMenu";

//$q.dark.isActive
const $q = useQuasar();
let dark = ref(true);
const { Info, Error } = useMsg();

watch(() => dark.value, (newVal) => {
  $q.dark.set(newVal);
})

let leftDrawerOpen = ref(false);

let store = useStore();
const router = useRouter();
const { ajax, errmsg } = useAxios();

const { tokenHeaders, user, roleIcon, isAdmin, isTyper } = storeToRefs(store);
const { login, logout, isLogin } = store;

const sysLogout = () => {
  logout();
  Info("系統己經登出");
  router.push("/login");
};

onMounted(() => {
  const redirect = () => {
    const fullPath = router.currentRoute.value.fullPath;
    if (fullPath != "/login" && fullPath != "/about") router.push("/login");
  }

  merge(fromEvent(window, "mousemove"), fromEvent(window, "keydown"))
    .pipe(throttleTime(1000 * 60 * 5))
    .subscribe(() => {
      if (isLogin()) {
        ajax
          .get("/login/re", tokenHeaders.value)
          .then((res) => {
            login(res.data);
          })
          .catch((err) => {
            Error(errmsg(err));
            logout();
            redirect();
          });
      } else {
        redirect();
      }
    });

  let hour = moment().hour();
  if (hour > 17 || hour < 7) {
    $q.dark.set(true);
    dark.value = true;
  }
  else {
    $q.dark.set(false);
    dark.value = false;
  }

});
</script>
